'use client'

import {
   ActionIcon,
   Avatar,
   Blockquote,
   Card,
   Grid,
   Paper,
   Stack,
   Text
} from '@blocks'
import {IconBrandLinkedinFilled} from '@tabler/icons-react'
import Link from 'next/link'

export const Who = () => {
   return (
      <Stack
         id={'who'}
         my={100}
         gap={35}
      >
         <Stack gap={5}>
            <Text
               c={'#cb95ff'}
               fw={500}
               ta={'center'}
            >
               LEADERSHIP
            </Text>
            <Text
               c={'white'}
               fz={40}
               fw={650}
               ta={'center'}
            >
               Who We Are
            </Text>
         </Stack>
         <Card
            p={0}
            bg={'white'}
            shadow={'xl'}
            radius={'lg'}
         >
            <Grid columns={5}>
               <Grid.Col span={{base: 5, md: 2}}>
                  <Paper
                     h={'100%'}
                     p={50}
                     radius={0}
                     style={{
                        background:
                           'linear-gradient(153deg, #892ccf, #431c58)'
                     }}
                  >
                     <Stack
                        h={'100%'}
                        align={'center'}
                        justify={'center'}
                     >
                        <Avatar
                           src={'/professional.jpg'}
                           bd={'5px solid #ffffff70'}
                           size={200}
                        />
                        <Stack
                           gap={0}
                           align={'center'}
                           justify={'center'}
                        >
                           <Text
                              c={'white'}
                              fz={26}
                              fw={650}
                           >
                              Ravi Sohal
                           </Text>
                           <Text
                              c={'#f3f3f3'}
                              fz={20}
                           >
                              Founder & Technical Director
                           </Text>
                        </Stack>
                        <Link
                           href='https://www.linkedin.com/in/sohalravi'
                           target='_blank'
                           rel='noopener noreferrer'
                        >
                           <ActionIcon
                              size={50}
                              color={'white'}
                              variant={'light'}
                              radius={'xl'}
                           >
                              <IconBrandLinkedinFilled size={25} />
                           </ActionIcon>
                        </Link>
                     </Stack>
                  </Paper>
               </Grid.Col>
               <Grid.Col span={{base: 5, md: 3}}>
                  <Stack
                     p={60}
                     bg={'white'}
                     gap={30}
                  >
                     <Text
                        c={'#374151'}
                        fz={19}
                        fw={450}
                        lh={1.5}
                     >
                        Kodra was founded by Ravi Sohal, a technology
                        leader with over a decade of experience
                        delivering digital products across industries
                        and platforms—from global consulting firms
                        like Infosys to high-growth startup
                        environments.
                     </Text>
                     <Blockquote
                        p={'sm'}
                        c={'#374151'}
                        fz={19}
                        fw={450}
                        lh={1.5}
                        color={'#83559a'}
                     >
                        His work as a CTO has been recognised on The
                        Australian&apos;s Top 100 Innovators list for
                        innovation in AI and technology for 2025.
                     </Blockquote>
                     <Text
                        c={'#374151'}
                        fz={19}
                        fw={450}
                        lh={1.5}
                     >
                        After years of building and leading
                        enterprise-grade software, Ravi created Kodra
                        to offer a more intentional, design-forward
                        approach to digital delivery—one that removes
                        complexity for clients and focuses on outcomes
                        that last.
                     </Text>
                  </Stack>
               </Grid.Col>
            </Grid>
         </Card>
      </Stack>
   )
}
